// React
import React from 'react';

// Hooks and utils
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

// Components
import SecondParty from './SecondParty';
import SecondPartyDisplay from './SecondPartyDisplay';

// Styles
import styles from './styles';

function Party(props) {
  const {
    classes,
    locale,
    company,
    pmaType,
    individual,
    secondPartyType,
    isRenewal,
    isAmendment,
    application,
    fetchCompanyDetails,
    fetchUserDetails,
  } = props;

  return (
    <div className={classes.contentArea}>
      {!isRenewal && !isAmendment && (
        <SecondParty
          fetchCompanyDetails={fetchCompanyDetails}
          locale={locale}
          company={company}
          pmaType={pmaType}
          individual={individual}
          fetchUserDetails={fetchUserDetails}
          secondPartyType={secondPartyType}
          isRenewal={isRenewal}
        />
      )}
      {(isRenewal || isAmendment) && application?.secondPartyMissing && (
        <SecondParty
          fetchCompanyDetails={fetchCompanyDetails}
          locale={locale}
          company={company}
          pmaType={pmaType}
          individual={individual}
          fetchUserDetails={fetchUserDetails}
          secondPartyType={secondPartyType}
          isRenewal={isRenewal}
          error={false}
        />
      )}
      {(isRenewal || isAmendment) && !application?.secondPartyMissing && (
        <SecondPartyDisplay
          locale={locale}
          company={company}
          pmaType={pmaType}
          individual={individual}
          fetchUserDetails={fetchUserDetails}
          secondPartyType={secondPartyType}
          isRenewal={isRenewal}
        />
      )}
    </div>
  );
}

Party.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  company: PropTypes.object.isRequired,
  individual: PropTypes.object.isRequired,
  pmaType: PropTypes.string.isRequired,
  fetchUserDetails: PropTypes.number.isRequired,
  fetchCompanyDetails: PropTypes.string.isRequired,
  secondPartyType: PropTypes.string.isRequired,
  isRenewal: PropTypes.bool.isRequired,
  isAmendment: PropTypes.bool.isRequired,
  application: PropTypes.object.isRequired,
};

export default withStyles(styles)(Party);
